import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

const Cell = styled.td`
  padding: 15px 25px;
  font-size: 14px;
  word-break: keep-all;
  background: ${(p) => p.theme.colors.card};

  ${mediaqueries.desktop`
    padding: 14px 20px;
  `}

  ${mediaqueries.tablet`
    font-size: 14px;
  `}
`;

export default Cell;
